import clsx from 'clsx';
import React from 'react';
import { getUserGUID } from 'utils/commonFunctions';
import { rankMap } from 'utils/constants';

const Grid = ({ children }) => {
  return <div className='si-lb'>{children}</div>;
};

Grid.Head = () => {
  return (
    <div className='si-lb__head'>
      <div className='si-lb__row'>
        <div className='si-lb__col si-lb__col--name'>
          <div className='si-lb__rank'>Rank</div>
          <div className='si-lb__name'>
            <div className='si-lb__user'>Name</div>
          </div>
        </div>
        <div className='si-lb__col si-lb__col--pts'>
          <div className='si-lb__pts'>Points </div>
        </div>
      </div>
    </div>
  );
};

Grid.Body = ({ rows }) => {
  return (
    <div className='si-lb__body'>
      {rows?.map((row, index) => (
        <div
          key={index}
          className={clsx(`si-lb__row`, {
            'si-lb__user-rank si-sticky--bottom': row.guid === getUserGUID()
            // 'si-lb--first': row.rank == 1 && row.guid === getUserGUID(),
            // 'si-lb--second': row.rank == 2 && row.guid === getUserGUID(),
            // 'si-lb--third': row.rank == 3 && row.guid === getUserGUID()
          })}
        >
          {/* si-lb__user-rank | si-lb--first | si-lb--second | si-lb--third | si-sticky--bottom*/}
          <div className='si-lb__col si-lb__col--name'>
            <div className='si-lb__rank'>
              {row.rank > 3 ? null : (
                <img src={require(`assets/images/lb-${rankMap?.[row?.rank] ?? 'first'}.png`)} />
              )}
              <span>{row.rank}</span>
            </div>
            <div className='si-lb__name'>
              <div className='si-lb__user-name'>
                {row.guid === getUserGUID() ? row.fullname + ' (You)' : row.fullname}
              </div>
            </div>
          </div>
          <div className='si-lb__col si-lb__col--pts'>{row.overallpoints}</div>
        </div>
      ))}
    </div>
  );
};

Grid.Load = ({ children, handleLoadMore }) => {
  return (
    <div onClick={handleLoadMore} className='si-lb__row si-lb__loader'>
      <span href='' className='si-btn'>
        {children}
      </span>
    </div>
  );
};

export { Grid };
